
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security-wait/[month]",
      function () {
        return require("private-next-pages/security-wait/[month].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security-wait/[month]"])
      });
    }
  